import { INITIALIZE_LOCATION_FORM } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (values) => creditFileActions[INITIALIZE_LOCATION_FORM](values);
